export default function pipelineNotInCluster(deployedPipeline) {
  return deployedPipeline.errors?.message.includes('404');
}
